import Form from "components/forms/Form";

import * as Styled from "./styles";
import { MainCreationFormProps } from "./types";

// eslint-disable-next-line react/function-component-definition
function MainCreationForm<T = unknown>({
  $isReadOnly,
  ...props
}: MainCreationFormProps<T>) {
  return (
    <Styled.FormWrapper {...{ $isReadOnly }}>
      <Form<T> {...props} />
    </Styled.FormWrapper>
  );
}

export default MainCreationForm;
